/**
 * Handles show/hide for all conditional form field blocks
 */
 export default function conditionalField() {

  // Get the field value of the block
  const getFieldValue = id => {
    const block = document.querySelector(`[data-sw-block-id="${id}"]`);
    const input = block ? block.querySelector('input') || block.querySelector('textarea') || block.querySelector('select') : false;
    return input ? input.form[input.name].value : false;
  }

  // Show/hide any blocks that are conditional for id
  const updateConditionalFields = id => {

    // check all conditional fields (where conditional id is id) against any new values...
    document.querySelectorAll(`[data-sw-conditional-block-id="${id}"]`).forEach(conditional => {

      // Get the conditional block value
      const condition = getFieldValue(id);

      // Hide/show the conditional block
      let show = conditional.dataset.swConditionalBlockValue.trim() === condition;
      if (!show) { // comma delineated values
        show = conditional.dataset.swConditionalBlockValue.split(',').filter(v => { return v.trim() === condition; }).length > 0;
      }
      conditional.classList[show ? 'remove' : 'add']('hidden');

      // Focus the first input of the block if showing
      const input = conditional.querySelector('input') || conditional.querySelector('textarea') || conditional.querySelector('select');
      if (show && input) input.focus();
    });
  }

  // Initial state and change
  document.querySelectorAll('[data-sw-block-id]').forEach(field => {
    const id = field.dataset.swBlockId;

    // Watch for changes on any fields that have block ids
    field.addEventListener('change', () => updateConditionalFields(id));

    // Initial state
    updateConditionalFields(id)
  });
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/conditional-fields.js